var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55565 5.26877C8.24824 5.26877 8.81491 4.71479 8.81491 4.03771C8.81491 3.36062 8.24824 2.80664 7.55565 2.80664C6.86305 2.80664 6.29639 3.36062 6.29639 4.03771C6.29639 4.71479 6.86305 5.26877 7.55565 5.26877ZM7.55565 6.49984C6.86305 6.49984 6.29639 7.05382 6.29639 7.73091C6.29639 8.408 6.86305 8.96198 7.55565 8.96198C8.24824 8.96198 8.81491 8.408 8.81491 7.73091C8.81491 7.05382 8.24824 6.49984 7.55565 6.49984ZM7.55565 10.193C6.86305 10.193 6.29639 10.747 6.29639 11.4241C6.29639 12.1012 6.86305 12.6552 7.55565 12.6552C8.24824 12.6552 8.81491 12.1012 8.81491 11.4241C8.81491 10.747 8.24824 10.193 7.55565 10.193Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/MoreIcon.d2808ac85aa43c87da7d1030af04dae9.svg";
export { ForwardRef as ReactComponent };